import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AddressContent } from '../../../pages/common/data-privacy/data-privacy.interface';

@Component({
  selector: 'app-address',
  imports: [],
  templateUrl: './address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressComponent {
  readonly address = input.required<AddressContent>();
}
